import { SERVICES_API_BASE_URL } from './apiConfig';

export interface BrandingData {
  companyName: string;
  address: string;
  contactNumber: string;
  logoUrl: string;
  termsOfService: string;
  about: string;
  logoFile?: File;
}

export const API_HOST = SERVICES_API_BASE_URL;
const API_URL = `${API_HOST}/api/branding`;

export const getBranding = async (): Promise<BrandingData | null> => {
  const response = await fetch(API_URL, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    }
  });
  if (!response.ok) return null;
  return response.json();
};

export const updateBranding = async (data: BrandingData): Promise<void> => {
  const formData = new FormData();
  formData.append("companyName", data.companyName);
  formData.append("address", data.address);
  formData.append("contactNumber", data.contactNumber);
  formData.append("termsOfService", data.termsOfService || '');
  formData.append("about", data.about || '');
  
  if (data.logoFile) {
    formData.append("logo", data.logoFile);
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    },
    body: formData,
  });
  if (!response.ok) throw new Error('Failed to save branding');
};